import {IntlKeyValuePair, IntlNamespaces} from "./types";

export const INTL_SUCCESS_MESSAGE: IntlKeyValuePair = {
    key: "successMessage",
    defaultValue: "An email with verification code has been sent.",
    intlValue: "An email with verification code has been sent.",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_PAGE_TITLE: IntlKeyValuePair = {
    key: "pageTitle",
    defaultValue: "Sign up to Unibuddy",
    intlValue: "Sign up to Unibuddy",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_VERIFICATION_INSTRUCTIONS: IntlKeyValuePair = {
    key: "verificationInstructions",
    defaultValue:
        "We’ve sent a verification code to the email address you used to create this account. Check your email, and type the verification code into the field below. You can request a new code after 2 hours.",
    intlValue:
        "We’ve sent a verification code to the email address you used to create this account. Check your email, and type the verification code into the field below. You can request a new code after 2 hours.",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_VERIFY_EMAIL: IntlKeyValuePair = {
    key: "verifyEmail",
    defaultValue: "Verify email address",
    intlValue: "Verify email address",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_RESEND_EMAIL: IntlKeyValuePair = {
    key: "resendEmail",
    defaultValue: "Resend verification email",
    intlValue: "Resend verification email",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_TROUBLE_SIGNUP_INSTRUCTIONS: IntlKeyValuePair = {
    key: "troubleSignupInstructions",
    defaultValue:
        "<0>Having trouble accessing the email address you provided? You can change the email address used to create your account by <2>clicking here</2>.</0>",
    intlValue:
        "<0>Having trouble accessing the email address you provided? You can change the email address used to create your account by <2>clicking here</2>.</0>",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_VERIFICATION_CODE: IntlKeyValuePair = {
    key: "verificationCode",
    defaultValue: "Verification code",
    intlValue: "Verification code",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_UPDATE_EMAIL: IntlKeyValuePair = {
    key: "updateEmail",
    defaultValue: "Enter a new email address to update the email used to create your account.",
    intlValue: "Enter a new email address to update the email used to create your account.",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_EMAIL: IntlKeyValuePair = {
    key: "email",
    defaultValue: "Email",
    intlValue: "Email",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_CHANGE_EMAIL: IntlKeyValuePair = {
    key: "changeEmail",
    defaultValue: "Change email address",
    intlValue: "Change email address",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_CANCEL: IntlKeyValuePair = {
    key: "cancel",
    defaultValue: "Cancel",
    intlValue: "Cancel",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_UPDATE_EMAIL_HEADER: IntlKeyValuePair = {
    key: "updateEmailHeader",
    defaultValue: "Update email address",
    intlValue: "Update email address",
    namespace: IntlNamespaces.VERIFICATION,
};

export const INTL_CHECK_EMAIL: IntlKeyValuePair = {
    key: "checkEmail",
    defaultValue: "Let's check that email",
    intlValue: "Let's check that email",
    namespace: IntlNamespaces.VERIFICATION,
};
